module.exports = __webpack_public_path__ + "static/media/electric.0d7643e5.jpg";